import React from 'react';
import { Podcast } from '../types';

interface PodcastListProps {
  podcasts: Podcast[];
  onSelect: (podcast: Podcast) => void;
  onDelete: (podcastId: string) => void;
}

const PodcastList: React.FC<PodcastListProps> = ({ podcasts, onSelect, onDelete }) => {
  if (podcasts.length === 0) {
    return (
      <div className="empty-state">
        <p>No podcasts yet. Click "+ Add" to subscribe to a podcast!</p>
      </div>
    );
  }

  return (
    <div className="podcast-list">
      {podcasts.map((podcast) => (
        <div key={podcast.id} className="podcast-list-item">
          {podcast.imageUrl && (
            <img src={podcast.imageUrl} alt={podcast.title} className="podcast-cover" />
          )}
          <div className="podcast-list-info">
            <div className="podcast-list-title" onClick={() => onSelect(podcast)}>
              {podcast.title}
            </div>
            <div className="podcast-list-author">{podcast.author}</div>
            <a
              href={podcast.feedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="podcast-feed-link"
              onClick={(e) => e.stopPropagation()}
            >
              {podcast.feedUrl}
            </a>
          </div>
          <button
            onClick={() => {
              if (window.confirm(`Remove "${podcast.title}"?`)) {
                onDelete(podcast.id);
              }
            }}
            className="delete-podcast-btn"
            title="Remove podcast"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default PodcastList;
